import React from 'react';
import Icon from '../Icon';

 
/* tslint:disable */
const CloseThin = (props: any) => (
  <Icon viewBox="-2.4 21.6 9.7 9.7" {...props}>
    <g>
      <path
        d="M7.3 22.4l-.7-.8-4.1 4.2-4.1-4.2-.8.8 4.2 4.1-4.2 4.1.8.7 4.1-4.1 4.1 4.1.7-.7-4.1-4.1z"
        className="st0"
      />
    </g>
  </Icon>
);
/* tslint:enable */
 

export default CloseThin;
